import type { RouteLocationRaw } from 'vue-router'
import type { NotificationItem } from '@/queries/notifications/types'

const text = (value: unknown) => (typeof value === 'string' ? value : '')
const identifier = (value: unknown): string | null => {
  const id =
    typeof value === 'string'
      ? value.trim()
      : typeof value === 'number' && Number.isFinite(value)
        ? String(value)
        : ''
  return id && id !== '0' && id !== '-1' && /^[\w-]+$/.test(id) ? id : null
}

export function normalizeNotification(value: unknown): NotificationItem | null {
  if (!value || typeof value !== 'object') return null
  const record = value as Record<string, unknown>
  const id = identifier(record.id)
  if (!id) return null
  return {
    id,
    title: text(record.title),
    description: text(record.description),
    type: Number(record.type) || 0,
    seen: record.seen === true || record.seen === 1 || record.seen === '1',
    createdAt: text(record.createdAt),
    data:
      record.data && typeof record.data === 'object' && !Array.isArray(record.data)
        ? (record.data as Record<string, unknown>)
        : {}
  }
}

export function getNotificationTarget(
  item: NotificationItem
): RouteLocationRaw | null {
  if (item.type === 1 || item.type === 5) {
    const userId = identifier(item.data.followed_id) ?? identifier(item.data.userId)
    return userId ? { name: 'other_user_profile', params: { userId } } : null
  }
  if (item.type === 8) {
    const courseId = identifier(item.data.courseId)
    return courseId
      ? { name: 'course_detail', params: { course_id: courseId } }
      : null
  }
  if (item.type === 7) return { name: 'DayStreak' }
  return null
}
